import { useEffect, useRef } from "react"

import { useToggle } from "react-use"

import { useTranslation } from "@l2r-front/l2r-i18n"

import { I18N_NAMESPACE } from "../../constants/i18n"

import { L2RButton } from "../L2RButton"

import * as Styled from "./TruncableText.styled"

type TruncableTextProps = {
    children: string,
    maxHeight?: number,
    fontSize?: number,
}

export function TruncableText(props: TruncableTextProps): React.ReactNode {

    const {
        children,
        maxHeight = 100,
        fontSize = 14,
        ...otherProps
    } = props

    const [showMore, toggleShowMore] = useToggle(false)
    const [showButton, setShowButton] = useToggle(false)
    const contentRef = useRef(null)

    const { t } = useTranslation(I18N_NAMESPACE)

    useEffect(() => {
        if (contentRef.current) {
            setShowButton(contentRef.current.scrollHeight > maxHeight)
        }
    }, [children, maxHeight, setShowButton])

    return (
        <Styled.Container {...otherProps}>
            <Styled.Content ref={contentRef} maxHeight={showMore ? "none" : maxHeight} fontSize={fontSize}>
                {children}
            </Styled.Content>
            {showButton && <L2RButton variant="text" onClick={toggleShowMore}>
                {t(I18N_NAMESPACE, showMore ? "components.truncableText.seeLess" : "components.truncableText.seeMore")}
            </L2RButton>}
        </Styled.Container>
    )
}
